import React, { useEffect, useState, useRef } from "react";
import Postmonger from "postmonger";
import Main from "./Main";
import { AlertProvider } from "../AlertProvider";
import "../App.css";
import useStore from "../Store";
import ApiRequest from "../ApiRequest";

const App = () => {
  const schemaRef = useRef([]); // ← 렌더 사이에서도 유지

  const [postmonger, setPostmonger] = useState(null);

  // mapper, header에서 필요한 함수/변수들 추출
  const {
    defields,
    setDefields,
    initData,
    setInitData,
    setMapping,
    applyMappingData,
  } = useStore((state) => state.mapper);

  const {
    save,
    setDate,
    actId,
    setActId,
    journeyId,
    setJourneyId,
    getAuth,
    eventId,
    setEventId,
    initActivity,
    setInitActivity,
    setJourneyType,
    interactionId,
    setInteractionId,
    selectedChannelName,
    setSelectedChannelName,
  } = useStore((state) => state.header);

  // ---------------------------------------------------------------------
  // Initialize Postmonger session and define event listeners
  // ---------------------------------------------------------------------
  useEffect(() => {
    const session = new Postmonger.Session();

    // const handleInitActivity = async (data) => {
    //   console.log('체크1-----');
    //   console.log("handleInitActivity", data);
    //   console.log('체크2-----');
        
    //   // 1) inArguments 꺼내기 & identifier 세팅
    //   if (!data.arguments?.execute?.inArguments) {
    //     data.arguments.execute.inArguments = [];
    //   }
    //   const inArguments = data.arguments.execute.inArguments;

    //   let idObj = inArguments.find((arg) => arg.identifier);
    //   if (!idObj) {
    //     idObj = {
    //       identifier: btoa(setDate(new Date()) + Math.random()),
    //     };
    //     inArguments.push(idObj);
    //   }
    //   // Store에 actId 세팅
    //   setActId(idObj.identifier);

    //   // ←★ 2) 먼저 channelName 복원하기
    //   const channelArg = inArguments.find((arg) => arg.channelName) || {};
    //   const channel = channelArg.channelName || "";
    //   console.log("channel", channel);
    //   setSelectedChannelName(channel);

    //   // -------------- 여기서 템플릿을 미리 불러옵니다 --------------
    //   if (channel) {
    //     // header.getTemplates는 선택된 채널의 템플릿 목록을 서버에서 가져옵니다.
    //     await useStore.getState().header.getTemplates(channel);
    //   }
    //   // -------------------------------------------------------------


    //   // 3) DB에서 매핑 조회 (channelName 파라미터로 넘김)
    //   const res = await ApiRequest.post("/db/fetchData", {
    //     query: "SELECT * FROM mapping WHERE eventId = @inputId",
    //     params: {
    //       inputId: idObj.identifier,
    //       channelName: channel,
    //     },
    //   });

    //   let templates = [];
    //   if (Array.isArray(res) && res.length) {
    //     const mappingArr = JSON.parse(res[0].mapping);

    //     // 3-1) channelName 이미 복원했으니 넘어가도 됩니다

    //     // 3-2) 템플릿 복원
    //     if (channel) {
    //       // 이미 로드했어도, 없으면 다시 로드
    //       templates =
    //         templates.length > 0
    //           ? templates
    //           : await useStore
    //               .getState()
    //               .header.getTemplates(channel);
    //     }
    //     const tmplMap = mappingArr.find(
    //       (i) => i.name === "selectedTemplate"
    //     );
    //     if (tmplMap?.value) {
    //       const matched = templates.find(
    //         (t) => t.msg_no == tmplMap.value
    //       );
    //       if (matched) {
    //         useStore
    //           .getState()
    //           .header.setSelectedTemplate(matched);
    //       }
    //     }

    //     // 3-3) 나머지 inArguments 복원
    //     applyMappingData(res[0].mapping);
    //   }

    //   // // 4) 최종 initActivity state 셋
    //   // setInitActivity({
    //   //   ...data,
    //   //   arguments: {
    //   //     execute: { inArguments },
    //   //   },
    //   // });

    //   // ✅ 이렇게 “data” 그대로 보존하면서 inArguments만 교체
    //   const activity = { ...data };
    //   activity.arguments.execute.inArguments = inArguments;
    //   setInitActivity(activity);
    // };

    const handleInitActivity = async (data) => {

      // 1) execute/inArguments 안전 확보 (기존 url/verb/timeout 보존)
      const prevExecute = data.arguments?.execute || {};
      const prevInArgs  = Array.isArray(prevExecute.inArguments) ? prevExecute.inArguments : [];

      // 2) 첫 객체 준비
      const first = prevInArgs[0] ? { ...prevInArgs[0] } : {};
      // 3) identifier를 첫 객체에 업서트 (별도 객체로 두지 않음)
      if (!first.identifier) {
        first.identifier = btoa(setDate(new Date()) + Math.random());
      }
      setActId(first.identifier);
      // 4) 기본 토큰 시딩 (기존 값이 있으면 유지)
      first.key       = first.key       || "{{Contact.Key}}"; // 대문자 K
      // 스키마에서 Display Name이 'Contact First Name'인 항목의 API Name을 찾아 그대로 넣기
      const fnField = schemaRef.current.find(f => f.name === "Contact First Name");

      if (!first.firstname && fnField?.key) {
        first.firstname = `{{${fnField.key}}}`;  // ← 오타 없이 정확히
      }

      // ★ 기존 inArguments에서 channelName 있으면 스토어에 먼저 반영
      const existingChannel =
        first.channelName ||
        (prevInArgs.find(o => Object.prototype.hasOwnProperty.call(o, "channelName"))?.channelName) || "";
      if (existingChannel) setSelectedChannelName(existingChannel);

      // 5) 나머지 요소(혹시 남아있던 identifier 전용 객체 등) 유지하되, 중복 identifier 객체 제거
      const rest = prevInArgs.slice(1).filter(obj => !('identifier' in obj));
      const nextInArgs = [ first, ...rest ];

      // 6) 병합으로 execute 갱신
      const activity = { ...data };
      activity.arguments = {
        ...activity.arguments,
        execute: {
          ...prevExecute,
          inArguments: nextInArgs,
        }
      };
      
      setInitActivity(activity);

      console.log('seeded inArguments:', activity.arguments.execute.inArguments);
    };

    // Journey 정보(Interaction) 불러올 때
    const handleRequestedInteraction = async (data) => {        
      if (data.id) {
        setJourneyId(data.id);
        setInteractionId(data.definitionId);
      }
      if (data.triggers?.length) {
        const meta = data.triggers[0].metaData;
        if (meta.eventDefinitionId) {
          setEventId(meta.eventDefinitionId);
        } else if (meta.eventDefinitionKey) {
          const baseURL = "https://mcbh8y7162xy23b8";
          const token = getAuth.tokens; // 필요에 맞게 수정
          // ... eventDefinitionKey 로직
        }
        setJourneyType(
          data.triggers[0].type === "APIEvent"
            ? "triggered"
            : "segment"
        );
      }
    };

    // Journey Audience Schema
    const handleRequestedSchema = (data) => {
      schemaRef.current = Array.isArray(data?.schema) ? data.schema : [];

      console.log("=== Requested Schema Fields ===");
      schemaRef.current.forEach((field) =>  {
        console.log("API Name:", field.key);
        console.log("Display Name:", field.name);
      });
      console.log("=== End Schema Fields ===");

      if (data.schema) {
        setDefields(
          data.schema.reduce((acc, item) => {
            if (item.name) {
              const name =
                item.name.includes("First ") ||
                item.name.includes("Last ")
                  ? item.name
                      .replace("First ", "")
                      .replace("Last ", "")
                  : item.name;
              if (!acc.includes(name)) acc.push(name);
            }
            return acc;
          }, [])
        );
      }
    };

    // Postmonger Event Listeners
    session.on("initActivity", handleInitActivity);
    session.on(
      "requestedInteraction",
      handleRequestedInteraction
    );
    session.on(
      "requestedTokens",
      (tokens) => getAuth(tokens.EID, tokens.MID)
    );
    session.on("requestedSchema", handleRequestedSchema);

    session.on("clickedNext", async () => {
      const { initActivity, selectedChannelName } = useStore.getState().header;
      const data = { ...initActivity };

      const prevExecute = data.arguments?.execute || {};
      const inArgs = Array.isArray(prevExecute.inArguments) ? [...prevExecute.inArguments] : [];


      // 최소 1개 객체 보장 (기존 첫 객체 유지)
      if (inArgs.length === 0) inArgs.push({});

      const fnField = schemaRef.current.find(f => f.name === "Contact First Name");

      // ★ 첫 객체에 필수 필드 “업서트”
      inArgs[0] = {
        // 1) 꼭 필요한 키들 우선 보장
        identifier: inArgs[0].identifier || (useStore.getState().header.actId || ""),
        key:        inArgs[0].key        || "{{Contact.Key}}", // 대문자 K
        firstname:  inArgs[0].firstname || (fnField?.key ? `{{${fnField.key}}}` : inArgs[0].firstname),

        contactKey: inArgs[0].contactKey || "{{Contact.Key}}",
        channelName: selectedChannelName,
        // 2) 기존 값 유지
        ...inArgs[0],
      };

      data.arguments = {
        ...data.arguments,
        execute: {
          ...prevExecute,
          inArguments: inArgs
        }
      };

      data.metaData = { ...(data.metaData || {}), isConfigured: true };

      setInitActivity(data);
      await setMapping();
      console.log('execute before updateActivity:', data.arguments.execute); // 디버깅용
      session.trigger("updateActivity", data);
    });

    session.on("updateActivity", setInitActivity);
    session.on("ready", console.log);

    // 필수 trigger
    session.trigger("ready");
    session.trigger("requestTokens");
    session.trigger("requestEndpoints");
    session.trigger("requestInteraction");
    session.trigger("requestSchema");

    setPostmonger(session);
  }, [
    setDate,
    setDefields,
    setMapping,
    getAuth,
    setActId,
    setJourneyId,
    setInteractionId,
    setEventId,
    setJourneyType,
    setInitActivity,
    setSelectedChannelName,
  ]);

  // actId, journeyId 설정되면 initData
  useEffect(() => {
    if (actId && journeyId) {
      setInitData(actId);
    }
  }, [actId, journeyId, setInitData]);

  // 채널 바뀔 때마다 템플릿 미리 로드
  useEffect(() => {
    if (selectedChannelName) {
      useStore
        .getState()
        .header.getTemplates(selectedChannelName);
    }
  }, [selectedChannelName]);

  // 노드 재오픈 시에도 mapping JSON 복원
  useEffect(() => {
    async function fetchMappingData() {
      if (!actId || !postmonger) return;  // ← 여기 추가
      console.log('노드 재오픈 시1 -----');
      console.log('actId', actId);
      console.log('selectedChannelName', selectedChannelName);
      console.log('노드 재오픈 시2 -----');


      // 재개된 세션에서 사용자가 이전에 선택한 채널이 있으면 템플릿을 불러옵니다.
      if (selectedChannelName) {
        await useStore.getState().header.getTemplates(selectedChannelName);
      }

      // ★ 채널이 없으면 후보 채널을 돌면서 조회 (환경에 맞게 리스트 조정)
      const tryChannels = selectedChannelName ? [selectedChannelName] : ["DBU", "RBU", "OBU"];
      let result;
      for (const ch of tryChannels) {
        const res = await ApiRequest.post("/db/fetchData", {
          query: "SELECT * FROM mapping WHERE eventId = @inputId",
          params: { inputId: actId, channelName: ch },
        });
        const rows = Array.isArray(res?.data) ? res.data : res;
        if (Array.isArray(rows) && rows.length > 0) {
          if (!selectedChannelName) setSelectedChannelName(ch);
          result = rows;
          break;
        }
      }
      if (!result) return;

      // ★ 반드시 템플릿을 먼저 로드한 뒤 매핑 적용
      const channelForTemplates = selectedChannelName || (tryChannels.find(Boolean)) || "";
      if (channelForTemplates) {
        await useStore.getState().header.getTemplates(channelForTemplates);
      }

      if (Array.isArray(result) && result.length > 0) {
        applyMappingData(result[0].mapping);
      }
      
    }
    fetchMappingData();
  }, [
    actId,
    selectedChannelName,
    applyMappingData,
    postmonger,
  ]);

  // save 플래그에 따라 updateActivity
  const [prevSave, setPrevSave] = useState(save);
  useEffect(() => {
    if (save && save !== prevSave && postmonger) {
      postmonger.trigger("updateActivity", initActivity);
    }
    setPrevSave(save);
  }, [save, prevSave, postmonger, initActivity]);

  return (
    <div id="main-container">
      <AlertProvider>
        <Main
          defields={defields}
          eventId={eventId}
          interactionId={interactionId}
          actId={actId}
        />
      </AlertProvider>
    </div>
  );
};

export default App;
